module.exports = __webpack_public_path__ + "static/media/support_illustration.1b0a986f.png";